export default __webpack_public_path__ + "static/media/product42.a6e7fa26.png";